import { useRef, useState } from "react";
import { UploadCloud, X, Film } from "lucide-react";

export default function FileDrop({ files, setFiles, testId, dark = false }) {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);

  const add = (list) => {
    const next = [...files, ...Array.from(list)].slice(0, 6);
    setFiles(next);
  };

  const remove = (idx) => setFiles(files.filter((_, i) => i !== idx));

  const base = dark
    ? "border-[#3a372f] bg-[#1a1917] text-[#a79f90]"
    : "border-[#DCD3C3] bg-[#F3EDE3] text-[#5C564C]";

  return (
    <div>
      <div
        onClick={() => inputRef.current?.click()}
        onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
        onDragLeave={() => setDragging(false)}
        onDrop={(e) => { e.preventDefault(); setDragging(false); add(e.dataTransfer.files); }}
        data-testid={testId}
        className={`cursor-pointer border border-dashed px-6 py-8 text-center transition-colors ${base} ${dragging ? "border-[#D4AF37]" : "hover:border-[#B38728]"}`}
      >
        <UploadCloud className="w-6 h-6 mx-auto text-[#B38728]" />
        <p className="mt-3 text-xs font-mono uppercase tracking-[0.2em]">
          Drop photos / videos or click to browse
        </p>
        <p className="mt-1 text-[10px] opacity-70">Up to 6 files · 25MB each</p>
        <input
          ref={inputRef}
          type="file"
          multiple
          accept="image/*,video/*"
          className="hidden"
          data-testid={`${testId}-input`}
          onChange={(e) => { add(e.target.files); e.target.value = ""; }}
        />
      </div>
      {files.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-3" data-testid={`${testId}-previews`}>
          {files.map((f, i) => (
            <div key={`${f.name}-${i}`} className={`relative border ${dark ? "border-[#3a372f]" : "border-[#DCD3C3]"} p-1`}>
              {f.type.startsWith("image/") ? (
                <img src={URL.createObjectURL(f)} alt={f.name} className="h-16 w-16 object-cover" />
              ) : (
                <div className="h-16 w-16 flex flex-col items-center justify-center gap-1">
                  <Film className="w-5 h-5 text-[#B38728]" />
                  <span className="text-[8px] font-mono truncate max-w-[3.5rem]">{f.name}</span>
                </div>
              )}
              <button
                type="button"
                onClick={() => remove(i)}
                data-testid={`${testId}-remove-${i}`}
                className="absolute -top-2 -right-2 bg-[#0A0A0A] text-[#F3EDE3] rounded-full p-0.5 hover:bg-[#B38728] hover:text-[#0A0A0A]"
              >
                <X className="w-3 h-3" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
